<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">誌面印刷</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                [(ngModel)]="kymw1402Model.orderCode" [required]="true" [catalogIDField]="lbl_DelivCatalog"
                (ngModelChange)="eventOrderCode_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-order-code-text-input>
            </div>

            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" id="lbl_DelivCatalog" class="deliv-catalog" #lbl_DelivCatalog readonly>
            </div>

            <label class="list-input-title">媒体</label>
            <div class="list-input-content colspan3">
              <app-koma-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'"
                [(ngModel)]="kymw1402Model.mediumType" [required]="true" [orderCode]="txti_OrderCode.selectedOrderCode"
                (change)="eventMediumType_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0" style="width: 100%;">
              </app-koma-medium-type-combo-box>
            </div>

            <label class="list-input-title">会員生協</label>
            <div class="list-input-content coop-codes">
              <app-checkbox-label id="chk_AllCoop" [subid]="'chk_AllCoop'" [(ngModel)]="kymw1402Model.chkAllCoop"
                [label]="'全'" (change)="eventAllCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Ibaraki" [subid]="'chk_Ibaraki'" [(ngModel)]="kymw1402Model.chkIbaraki"
                [label]="'い'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Tochigi" [subid]="'chk_Tochigi'" [(ngModel)]="kymw1402Model.chkTochigi"
                [label]="'と'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Gunma" [subid]="'chk_Gunma'" [(ngModel)]="kymw1402Model.chkGunma"
                [label]="'ぐ'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Chiba" [subid]="'chk_Chiba'" [(ngModel)]="kymw1402Model.chkChiba"
                [label]="'ち'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Saitama" [subid]="'chk_Saitama'" [(ngModel)]="kymw1402Model.chkSaitama"
                [label]="'さ'" (change)="eventCoop_CHANGEHandler()" forcedEnabledMode="true" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Tokyo" [subid]="'chk_Tokyo'" [(ngModel)]="kymw1402Model.chkTokyo"
                [label]="'とう'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Nagano" [subid]="'chk_Nagano'" [(ngModel)]="kymw1402Model.chkNagano"
                [label]="'な'" (change)="eventCoop_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label id="chk_Niigata" [subid]="'chk_Niigata'" [(ngModel)]="kymw1402Model.chkNiigata"
                [label]="'に'" (change)="eventCoop_CHANGEHandler()" forcedEnabledMode="true" [tabindex]="0">
              </app-checkbox-label>
            </div>
          </div>
          <div>
            <button id="btn_Display" class="btn-secondary" [disabled]="kymw1402Model.disabledDisplay"
              (click)="eventDisplay_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">表示</button>
          
            <div class="action-area">
              <button id="btn_AllSelect" class="btn-tartiary" (click)="eventAllSelect_CLICKHandler()"
                forcedEnabledMode="true" [tabindex]="0">全選択</button>
              <button id="btn_AllRelease" class="btn-tartiary" (click)="eventAllRelease_CLICKHandler()"
                forcedEnabledMode="true" [tabindex]="0">全解除</button>
            </div>
            <wj-flex-grid id="li_PageList" #li_PageList [itemsSource]="kymw1402Model.pageList" [allowDragging]="false"
              [isReadOnly]="true" [deferResizing]="false" [allowSorting]="false"
              [headersVisibility]="'Column'" [selectionMode]="'Row'" [tabindex]="0" [style.width.px]="720">
              <wj-flex-grid-column [minWidth]="5" [width]="50" [header]="'選択'" [binding]="'Selected'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" class="selected" [(ngModel)]="cell.item.Selected" [tabindex]="-1"
                    id="cb_page_list_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'ページ'" [binding]="'PageNum'" [align]="'left'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="580" [header]="'ページ名称'" [binding]="'PageInfo'" [align]="'left'">
              </wj-flex-grid-column>
            </wj-flex-grid>
            <div class="element-row page-grid-footer">
              <div class="block-row">
                <app-checkbox-label id="chk_ShowKoma" [subid]="'chk_ShowKoma'" [(ngModel)]="kymw1402Model.chkShowKoma"
                  [label]="'コマ情報の表示'" [selected]="true" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label id="chk_ShowGoods" [subid]="'chk_ShowGoods'" [(ngModel)]="kymw1402Model.chkShowGoods"
                  [label]="'商品情報の表示'" [selected]="true" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-checkbox-label>
                <app-checkbox-label id="chk_ShowImage" [subid]="'chk_ShowImage'" [(ngModel)]="kymw1402Model.chkShowImage"
                  [label]="'画像の表示'" [selected]="true" [forcedEnabledMode]="'true'" [tabindex]="0">
                </app-checkbox-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Out" class="btn-primary" (click)="eventOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventWindowClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>